import {
  ChartBar,
  ChatCircle,
  Users,
  Funnel,
  Gear,
  UsersFour,
  BellRinging,
  Lightning,
  CalendarBlank,
  ChartPie,
  UsersThree,
  EnvelopeSimple,
  PhoneCall,
  Fire,
  Robot,
  Car,
  Sword,
  ShieldCheck,
  Trophy,
  ChartLine,
  Notebook,
  Sparkle,
  Receipt,
} from '@phosphor-icons/react';

// Dealer Portal navigation — grouped for visual hierarchy
export const navGroups = [
  {
    label: 'Workspace',
    items: [
      { path: '/dashboard', icon: ChartBar, label: 'Dashboard' },
      { path: '/inbox', icon: ChatCircle, label: 'Inbox', badge: true },
      { path: '/approvals', icon: ShieldCheck, label: 'AI Approvals', badge: true },
      { path: '/calendar', icon: CalendarBlank, label: 'Calendar' },
    ]
  },
  {
    label: 'CRM & Sales',
    items: [
      { path: '/contacts', icon: Users, label: 'Contacts' },
      { path: '/pipeline', icon: Funnel, label: 'Pipeline' },
      { path: '/followups', icon: BellRinging, label: 'Action Center', badge: true },
    ]
  },
  {
    label: 'AI Engine',
    items: [
      { path: '/agents', icon: UsersFour, label: 'AI Agents' },
      { path: '/automations', icon: Lightning, label: 'Automations', feature: 'lifecycle_automations', advanced: true },
      { path: '/campaigns', icon: EnvelopeSimple, label: 'Campaigns', feature: 'campaigns', advanced: true },
      { path: '/inventory', icon: Car, label: 'Inventory' },
      { path: '/competitors', icon: Sword, label: 'Competitors', advanced: true },
    ]
  },
  {
    label: 'Performance',
    items: [
      { path: '/leaderboard', icon: Trophy, label: 'Leaderboard', advanced: true },
      { path: '/performance', icon: ChartLine, label: 'My Performance' },
    ]
  },
  {
    label: 'Tools',
    items: [
      { path: '/templates', icon: Notebook, label: 'Templates' },
    ]
  },
  {
    label: 'System',
    items: [
      { path: '/reports', icon: ChartPie, label: 'Reports', advanced: true },
      { path: '/dnc-audit', icon: ShieldCheck, label: 'DNC Audit' },
      { path: '/team', icon: UsersThree, label: 'Team', managerOnly: true },
      { path: '/billing', icon: Receipt, label: 'Billing', managerOnly: true },
      { path: '/add-ons', icon: Sparkle, label: 'Add-Ons', badge: true, badgeKey: 'addons' },
      { path: '/settings', icon: Gear, label: 'Settings' },
    ]
  },
];

// Flatten for filtering
export const navItems = navGroups.flatMap(g => g.items);

// Notification icon/color maps for GlassBubble
export const NOTIF_ICONS = {
  message: ChatCircle,
  robot: Robot,
  phone: PhoneCall,
  fire: Fire,
  bell: BellRinging,
};

export const NOTIF_COLORS = {
  new_message: { bg: 'from-blue-500 to-blue-600', ring: 'ring-blue-500/20' },
  ai_response: { bg: 'from-orange-400 to-orange-500', ring: 'ring-orange-500/20' },
  call_request: { bg: 'from-red-500 to-rose-600', ring: 'ring-red-500/20' },
  hot_lead: { bg: 'from-amber-400 to-orange-500', ring: 'ring-amber-500/20' },
  followup_due: { bg: 'from-violet-500 to-purple-600', ring: 'ring-violet-500/20' },
};
